const errors = {
    400: 'ERROR__INVALID_ID_PASSWORD',
    default: 'ERROR__LOGIN_SERVICE'
};

export default errors;
